import React from 'react';
import { Box, Typography } from "@curves/ui-base";
import clsx from 'clsx';
import {formatCardExpiryDate, formatCreditCardNo} from '@util/utils';
import {paymentTypeImageMap} from '@icoach/memberDetail/staticData';
import PaymentUnsetAlert from '@icoach/memberDetail/components/PaymentUnsetAlert';
import {OverflowMenu} from '@icoach/components';

const CreditCardPayment = ({className, sourceData, actions = []}) => {
    const {title, paymentType = 1, creditCardNo, cardExpiryDate, cardRelation, creditCardType = 1} = sourceData || {};

    const isNull = !creditCardNo;
    return (
        <Box className={clsx('payment-card', className)}>
            <Typography className={'payment-card-title'} variant="h6">
                {title}
            </Typography>
            <OverflowMenu actionButtonProps={{className: 'payment-card-btn'}} menuData={actions}/>
            <Box className="payment-card-wrap">
                {isNull ? (
                    <PaymentUnsetAlert/>
                ) : (
                    <React.Fragment>
                        <Box className="payment-card-img">
                            <img src={paymentTypeImageMap[paymentType][creditCardType]} alt=""/>
                        </Box>
                        <Box className="payment-card-content">
                            <Typography className={'pt-0'} variant="body1" component={'h6'}>
                                {formatCreditCardNo(creditCardNo)}
                            </Typography>
                            <Typography className={'mb-1 font-color-3'} variant="body2">
                                {cardExpiryDate ? `到期日：${formatCardExpiryDate(cardExpiryDate)}` : '到期日未設定'}
                            </Typography>
                            <Typography className={'mb-1 font-color-3'} variant="body2">
                                {cardRelation ? `${cardRelation}持有` : '非本人持有'}
                            </Typography>
                        </Box>
                    </React.Fragment>
                )}
            </Box>
        </Box>
    );
};

export default CreditCardPayment;
